import { createPortal } from 'react-dom';
import { useState, useContext } from 'react';

import ContextMenu from "./ContextMenu";
import { SelectedItemsContext, FigureInteractionEventDispatch } from './Contexts';

const STOP_PROPAGATION = e => e.stopPropagation();

export default function ContextMenuLayer({
  items,
  style={},
  onEvent=((args) => {
    debugger;

  }),
}){
  const [pos,setPos] = useState();

  const [openPath,setOpenPath] = useState([]);



  return (
    <>
      <div 
        onMouseDown={STOP_PROPAGATION} 
        onClick={STOP_PROPAGATION}
        onMouseUp={STOP_PROPAGATION}
        item="context-menu-layer" 
        ref={el => {
          if( !el ){
            return;
          }
          let cl = el.getBoundingClientRect();
          let newPos = {left:cl.left,top:cl.top};
          if( !pos ){ setPos(newPos) }
          else if( pos ){
            if( pos.left !== newPos.left || pos.top !== newPos.top ){
              setPos(newPos);
            }
          }
        }} style={{
          position:'absolute',
          top:0,
          left:'50%',
          ...style,
        }}>
        {true && pos && createPortal(
          <div onMouseDown={e => {
            e.stopPropagation();
          }}>
            <ContextMenu onEvent={onEvent} x={pos.left} y={pos.top} items={items} openPath={openPath} treeLevel={0} setOpenPath={setOpenPath} transform={'translate(-50%,calc(-100% - 5px)'}/>,
          </div>,
          document.body
        )}
      </div>
    </>

  )
}
